// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__eA73i"};